import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import { LoginInput, LoginResponse, LogoutInput } from './gwp-interface';

export const login = async (loginInput: LoginInput): Promise<LoginResponse> => {
  const res = await API.post(API_SERVICES.GWP_API, `/login`, {
    data: loginInput,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};

export const logout = async (logoutInput: LogoutInput): Promise<unknown> => {
  const res = await API.post(API_SERVICES.GWP_API, '/signout', {
    data: logoutInput,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};

export const activity = async (): Promise<unknown> => {
  const res = await API.patch(API_SERVICES.GWP_API, '/activity', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};
